import { useEffect, useRef, useState } from 'react';
import { io } from 'socket.io-client';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

const useMapWebSocket = (enabled = true) => {
  const [isConnected, setIsConnected] = useState(false);
  const [lastUpdate, setLastUpdate] = useState(null);
  const [stats, setStats] = useState(null);
  const socketRef = useRef(null);

  useEffect(() => {
    if (!enabled) return;

    // Créer la connexion WebSocket
    const socket = io(BACKEND_URL, {
      path: '/socket.io',
      transports: ['websocket', 'polling'],
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionAttempts: 5
    });

    socketRef.current = socket;

    // Événements de connexion
    socket.on('connect', () => {
      setIsConnected(true);
      toast.success('Connexion temps réel activée', { duration: 2000 });
      
      // S'abonner aux mises à jour de la carte
      socket.emit('subscribe_map_updates');
    });

    socket.on('disconnect', () => {
      setIsConnected(false);
      toast.error('Connexion temps réel perdue', { duration: 2000 });
    });

    socket.on('connection_status', (_data) => {
    });

    socket.on('subscription_confirmed', (_data) => {
    });

    // Mises à jour de la carte
    socket.on('map_update', (update) => {
      setLastUpdate(update);
      
      // Notification selon le type
      const messages = {
        new_chantier: '🏗️ Nouveau chantier ajouté',
        new_dommage: '⚠️ Nouveau dommage signalé',
        new_travaux: '🔧 Nouveaux travaux planifiés',
        update_status: '🔄 Statut mis à jour'
      };
      
      if (messages[update.type]) {
        toast.info(messages[update.type], { duration: 3000 });
      }
    });

    // Mises à jour des statistiques
    socket.on('stats_update', (data) => {
      setStats(data.stats);
    });

    // Gestion des erreurs
    socket.on('connect_error', (_error) => {
    });

    // Cleanup
    return () => {
      if (socket) {
        socket.emit('unsubscribe_map_updates');
        socket.disconnect();
      }
    };
  }, [enabled]);

  const sendUpdate = (type, data) => {
    if (socketRef.current && isConnected) {
      socketRef.current.emit('map_update', { type, data });
    }
  };

  return {
    isConnected,
    lastUpdate,
    stats,
    sendUpdate
  };
};

export default useMapWebSocket;
